import birdIcon from './birdIcon.svg'
import downIcon from './downIcon.svg'

export { birdIcon, downIcon }
